export default __webpack_public_path__ + "static/media/mail.1c90211e.svg";